import { Link } from 'react-router-dom';
import { BookImage, User } from 'lucide-react';
import { useAuthStore } from '../../state/authStore';
import { t } from '../../i18n';
import './site-header.css';

export function SiteHeader() {
  const status = useAuthStore((s) => s.status);

  return (
    <header className="site-header">
      <Link to="/" className="site-header-brand">
        <BookImage size={20} />
        <span>{t('common.appName')}</span>
      </Link>
      <nav className="site-header-nav">
        <Link to="/projecten">{t('nav.projects')}</Link>
        <Link to="/privacy">{t('nav.privacy')}</Link>
        {status === 'authenticated' ? (
          <Link to="/account" className="site-header-account">
            <User size={16} />
            {t('nav.account')}
          </Link>
        ) : (
          <Link to="/login">{t('nav.login')}</Link>
        )}
      </nav>
    </header>
  );
}
